import { render, staticRenderFns } from "./TagRelationTypeColumn.vue?vue&type=template&id=19394a7c&scoped=true&"
import script from "./TagRelationTypeColumn.vue?vue&type=script&lang=js&"
export * from "./TagRelationTypeColumn.vue?vue&type=script&lang=js&"
import style0 from "./TagRelationTypeColumn.vue?vue&type=style&index=0&id=19394a7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19394a7c",
  null
  
)

export default component.exports